exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-layouts-BaseLayout-___style__header___wsCZ9 {\n  background-color: #ffc837;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 700;\n  box-shadow: 0 0 6px -1px rgba(0, 0, 0, 0.4);\n  z-index: 100; }\n\n.src-layouts-BaseLayout-___style__header___wsCZ9 .src-layouts-BaseLayout-___style__nav___310Xe a {\n  margin: 0 6px;\n  font-weight: 900;\n  color: #000;\n  text-transform: none;\n  text-decoration: none;\n  opacity: 0.8; }\n\n.src-layouts-BaseLayout-___style__header___wsCZ9 .src-layouts-BaseLayout-___style__nav___310Xe a:hover {\n  opacity: 1; }\n", ""]);

// exports
exports.locals = {
	"header": "src-layouts-BaseLayout-___style__header___wsCZ9",
	"nav": "src-layouts-BaseLayout-___style__nav___310Xe"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./node_modules","./node_modules/grommet/node_modules"]}!./src/layouts/BaseLayout/style.scss
// module id = 222
// module chunks = 0